import React from 'react'
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import bgHome from '../assets/images/bgHome.jpeg'
import Destination from '../components/Destination'
import Footer from '../components/Footer';

const Home = () => {
    return (
        <div>
            <Navbar />
            <Hero
                cName="hero"
                heroImg={bgHome}
                headingText="Journey Beyond Borders, Expand Your Horizons"
                paraText="Experience education like never before with our innovative travel app. Seamlessly blend learning and adventure as you explore fascinating destinations worldwide. Discover, learn, and grow with immersive tours tailored to ignite curiosity and enrich your educational journey."
                linkText="Download Now"
                url="https://drive.google.com/drive/folders/1qN-VaZ_y2Gi1vqJI5HoyWmfIdwfm0mhL"
            />
            <Destination />
            <Footer />
        </div>
    )
}

export default Home
